module.exports = __webpack_public_path__ + "static/media/background.b1f0b863.jpg";